import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    wrapper: (theme) => ({
        '& .MuiInput-underline:after': {
            borderBottomColor: `${theme.colors.plantation} !important`
        },
        '& .MuiInputLabel-outlined': {
            mt: -0.5
        },
        '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -2px) scale(0.75)'
        },
        '& input': {
            color: theme.colors.plantation,
            fontFamily: `${theme.typography.fontFamily} !important`,
            fontWeight: 400
        },
        '& label': {
            color: theme.colors.plantation,
            fontFamily: `${theme.typography.fontFamily} !important`,
            fontWeight: 400
        }
    })
} satisfies Record<string, SxProps<Theme>>;

export default styles;
